// import React from 'react';
import { createChatBotMessage } from 'react-chatbot-kit';

import React from 'react';
import CustomBotMessage from './components/ChatBotMessage';
import CustomUserMessage from './components/UserMessage';
import ChatForm from './components/ChatForm';
import WaitingResponse from './components/WaitingResponse';


/////////////////

const generateConfig = (initConfig: any) => {
  return {
    initialMessages: [createChatBotMessage(`Hello world`, {})],
    customComponents: {
      //@ts-ignore
      botAvatar: () => null,
      //@ts-ignore
      userAvatar: () => null,
      botChatMessage: (props: any) => <CustomBotMessage {...props} title={initConfig.participants.bot?.name || 'Bot'} />,
      userChatMessage: (props: any) => <CustomUserMessage {...props} title={initConfig.participants.user?.name || 'You'} />
    },
    widgets: [
      {
        widgetName: 'chatForm',
        widgetFunc: (props: any) => {
          return <ChatForm {...props} />
        },
        props: {
          message: {},
          page: {}
        },
        mapStateToProps: [''],
      },
      {
        widgetName: 'waitingResponse',
        widgetFunc: (props: any) => {
          return <WaitingResponse {...props} />
        },
        props: {},
        mapStateToProps: [''],
      },
    ],
  }
}

export default generateConfig;
